import { TChannelResponseStatus } from '../../api/messages';
import { messageStrings } from '../../constants/strings';
import { Chip } from '../Chip';

export function ResponseStatusBadge({
  status,
}: {
  status?: TChannelResponseStatus | null;
}) {
  if (!status || status === 'RESPONDED') return null;
  const needsResponse = status === 'NEEDS_RESPONSE';
  return (
    <Chip
      filled
      className="shrink-0 whitespace-nowrap"
      bgColor={needsResponse ? 'bg-red-100' : 'bg-neutral-100'}
      textColor={needsResponse ? 'text-red-700' : 'text-neutral-600'}
      textSize="text-xs"
      padding="px-2 py-1"
    >
      {messageStrings.responseStatus[status]}
    </Chip>
  );
}
